import { connect } from 'react-redux';
import View from './AgeView';
import { currentClientId, isGoingForwardSelector } from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateData } from '../../AdvWorkflow/AdvWorkflowActions';
import {
  showPartner,
  principal,
  partner,
} from './AgeSelector';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  principal: principal(state, ownProps),
  partner: partner(state, ownProps),
  hasPartner: showPartner(state, ownProps),
  isGoingForward: isGoingForwardSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
